import { FLAVOR_CONFIG } from '@portal/constants/flavors';
import { AlternateFlavorConfig } from 'processes/ShopV2/ShopV2.types';
import { StoreCode } from 'schema/storeCode';

export const ALT_FLAVORS_BY_STORE: {
  [key in StoreCode]: AlternateFlavorConfig[];
} = {
  us: [
    {
      id: 'gid://shopify/Product/7265771749474',
      originalVariantId: 'gid://shopify/Product/7265771618402',
      color: '#E3BE38',
      title: 'Tropical',
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7265771847778',
      originalVariantId: 'gid://shopify/Product/7265771651170',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical',
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7265777975394',
      originalVariantId: 'gid://shopify/Product/7265777942626',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical'
    },
    {
      id: 'gid://shopify/Product/7393793245282',
      originalVariantId: 'gid://shopify/Product/7265771618402',
      color: FLAVOR_CONFIG.berry.color,
      title: FLAVOR_CONFIG.berry.title,
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7393807597666',
      originalVariantId: 'gid://shopify/Product/7265771651170',
      color: FLAVOR_CONFIG.berry.color,
      title: FLAVOR_CONFIG.berry.title,
      isComingSoon: false,
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7393794097250',
      originalVariantId: 'gid://shopify/Product/7265771618402',
      color: FLAVOR_CONFIG.citrus.color,
      title: FLAVOR_CONFIG.citrus.title,
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7393807335522',
      originalVariantId: 'gid://shopify/Product/7265771651170',
      color: FLAVOR_CONFIG.citrus.color,
      title: FLAVOR_CONFIG.citrus.title,
      isComingSoon: false,
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7331784687714', // AGZ Chocolate Mint ID
      originalVariantId: 'gid://shopify/Product/7396607721570', // AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolateMint.color,
      isComingSoon: false,
      title: FLAVOR_CONFIG.chocolateMint.title,
      originalPrice: 69,
      singlePrice: 69,
      multiplePrice: 69
    },
    {
      id: 'gid://shopify/Product/7331784720482', // AGZ Chocolate ID
      originalVariantId: 'gid://shopify/Product/7396607721570', // AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolate.color,
      isComingSoon: false,
      title: FLAVOR_CONFIG.chocolate.title,
      originalPrice: 69,
      singlePrice: 69,
      multiplePrice: 69
    },
    {
      id: 'gid://shopify/Product/7396615815266', // OTP AGZ Chocolate Mint ID
      originalVariantId: 'gid://shopify/Product/7396614668386', // OTP AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolateMint.color,
      title: FLAVOR_CONFIG.chocolateMint.title,
      isComingSoon: false,
      originalPrice: 99,
      singlePrice: 99,
      multiplePrice: 99
    },
    {
      id: 'gid://shopify/Product/7396618797154', // OTP AGZ Chocolate ID
      originalVariantId: 'gid://shopify/Product/7396614668386', // OTP AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolate.color,
      title: FLAVOR_CONFIG.chocolate.title,
      isComingSoon: false,
      originalPrice: 99,
      singlePrice: 99,
      multiplePrice: 99
    }
  ],
  au: [
    {
      id: 'gid://shopify/Product/7265771749474',
      originalVariantId: 'gid://shopify/Product/7265771618402',
      color: '#E3BE38',
      title: 'Tropical',
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7265771847778',
      originalVariantId: 'gid://shopify/Product/7265771651170',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical',
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7265777975394',
      originalVariantId: 'gid://shopify/Product/7265777942626',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical'
    }
  ],
  nz: [
    {
      id: 'gid://shopify/Product/7265771749474',
      originalVariantId: 'gid://shopify/Product/7265771618402',
      color: '#E3BE38',
      title: 'Tropical',
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7265771847778',
      originalVariantId: 'gid://shopify/Product/7265771651170',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical',
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7265777975394',
      originalVariantId: 'gid://shopify/Product/7265777942626',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical'
    }
  ],
  qa: [
    {
      id: 'gid://shopify/Product/7284720304171',
      originalVariantId: 'gid://shopify/Product/7284540342315',
      color: '#E3BE38',
      title: 'Tropical',
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7284720730155',
      originalVariantId: 'gid://shopify/Product/7284540440619',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical',
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7284721156139',
      originalVariantId: 'gid://shopify/Product/7284540702763',
      color: '#E3BE38',
      isComingSoon: false,
      title: 'Tropical'
    },
    {
      id: 'gid://shopify/Product/7415228596267',
      originalVariantId: 'gid://shopify/Product/7284540342315',
      color: FLAVOR_CONFIG.berry.color,
      title: FLAVOR_CONFIG.berry.title,
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7415233085483',
      originalVariantId: 'gid://shopify/Product/7284540440619',
      color: FLAVOR_CONFIG.berry.color,
      title: FLAVOR_CONFIG.berry.title,
      isComingSoon: false,
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7415225057323',
      originalVariantId: 'gid://shopify/Product/7284540342315',
      color: FLAVOR_CONFIG.citrus.color,
      title: FLAVOR_CONFIG.citrus.title,
      originalPrice: 99,
      singlePrice: 79,
      multiplePrice: 74.5
    },
    {
      id: 'gid://shopify/Product/7415231447083',
      originalVariantId: 'gid://shopify/Product/7284540440619',
      color: FLAVOR_CONFIG.citrus.color,
      title: FLAVOR_CONFIG.citrus.title,
      isComingSoon: false,
      originalPrice: 109,
      singlePrice: 89,
      multiplePrice: 84.5
    },
    {
      id: 'gid://shopify/Product/7428452745259',
      originalVariantId: 'gid://shopify/Product/7428449796139',
      color: FLAVOR_CONFIG.chocolateMint.color,
      title: FLAVOR_CONFIG.chocolateMint.title,
      isComingSoon: false,
      originalPrice: 79,
      singlePrice: 79,
      multiplePrice: 79
    },
    {
      id: 'gid://shopify/Product/7403909382187',
      originalVariantId: 'gid://shopify/Product/7428449796139',
      color: FLAVOR_CONFIG.mixedBerry.color,
      title: FLAVOR_CONFIG.mixedBerry.title,
      isComingSoon: false,
      originalPrice: 79,
      singlePrice: 79,
      multiplePrice: 79
    },
    {
      id: 'gid://shopify/Product/7334078316587', // Discounted AGZ Chocolate Mint ID
      originalVariantId: 'gid://shopify/Product/7428184703019', // Discounted AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolateMint.color,
      title: FLAVOR_CONFIG.chocolateMint.title,
      isComingSoon: false,
      originalPrice: 69,
      singlePrice: 69,
      multiplePrice: 69
    },
    {
      id: 'gid://shopify/Product/7334078578731', // Discounted AGZ Chocolate ID
      originalVariantId: 'gid://shopify/Product/7428184703019', // Discounted AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolate.color,
      title: FLAVOR_CONFIG.chocolate.title,
      isComingSoon: false,
      originalPrice: 69,
      singlePrice: 69,
      multiplePrice: 69
    },
    {
      id: 'gid://shopify/Product/7428453138475', // OTP AGZ Chocolate Mint ID
      originalVariantId: 'gid://shopify/Product/7403914493995', // OTP AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolateMint.color,
      title: FLAVOR_CONFIG.chocolateMint.title,
      isComingSoon: false,
      originalPrice: 99,
      singlePrice: 99,
      multiplePrice: 99
    },
    {
      id: 'gid://shopify/Product/7428451631147', // OTP AGZ Chocolate ID
      originalVariantId: 'gid://shopify/Product/7403914493995', // OTP AGZ Mixed Berry ID
      color: FLAVOR_CONFIG.chocolate.color,
      title: FLAVOR_CONFIG.chocolate.title,
      isComingSoon: false,
      originalPrice: 99,
      singlePrice: 99,
      multiplePrice: 99
    }
  ],
  uk: [],
  eu: [],
  dev: [],
  aud: [],
  nzd: [],
  eud: [],
  ukd: [],
  jp: []
};
